var render, staticRenderFns
import script from "./ProcessTree.vue?vue&type=script&lang=js&"
export * from "./ProcessTree.vue?vue&type=script&lang=js&"
import style0 from "./ProcessTree.vue?vue&type=style&index=0&id=45cc6a8d&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "45cc6a8d",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("G:\\CompanyProject\\HF-IM-sub-design\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('45cc6a8d')) {
      api.createRecord('45cc6a8d', component.options)
    } else {
      api.reload('45cc6a8d', component.options)
    }
    
  }
}
component.options.__file = "src/components/process/ProcessTree.vue"
export default component.exports